/**
 * Reads a tag id that no longer resolves to a tag as a label.
 *
 * Archived tags stay on the slides carrying them but drop out of `useTags()`, so anything
 * displaying a tag needs a fallback that still reads as the tag rather than vanishing.
 */
export const unslugTagId = (id: string) =>
  id.replace(/([A-Z])/g, " $1").replace(/^./, (c) => c.toUpperCase());
